import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "faq__title" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "faq__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("details", {
    open: _ctx.isOpen,
    class: "faq__item"
  }, [
    _withDirectives((_openBlock(), _createElementBlock("summary", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.title),
          class: "faq__title-text"
        }, null, 8, _hoisted_3),
        _createVNode(_component_IconBase, { class: "faq__expand" }, {
          default: _withCtx(() => [
            (!_ctx.isOpen)
              ? (_openBlock(), _createBlock(_component_IconPlus, { key: 0 }))
              : (_openBlock(), _createBlock(_component_IconMinus, { key: 1 }))
          ]),
          _: 1
        })
      ])
    ])), [
      [_directive_ripple]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}